import { Crown } from "lucide-react";
import { Mascot } from "@/components/game/Mascot";

// Rekabetçi skor tablosu: sıra, lider tacı ve lidere göre oranlı çubuk.
export const Leaderboard = ({ rows, title = "Puan durumu", highlight }) => {
  const sorted = [...rows].sort((a, b) => b.score - a.score);
  const top = Math.max(sorted[0]?.score || 0, 1);
  return (
    <div className="panel !rounded-[1.75rem] p-[1.6vh] space-y-[1.1vh]" data-testid="board-leaderboard">
      <p className="eyebrow !text-[1.5vh]">{title}</p>
      {sorted.map((r, i) => (
        <div key={r.id} className={`relative rounded-2xl overflow-hidden border-2 transition-transform duration-300 ${highlight === r.id ? "scale-[1.03]" : ""}`}
          style={{ borderColor: i === 0 && r.score > 0 ? "#FACC15" : `${r.color}55`, boxShadow: highlight === r.id ? `0 0 22px ${r.color}77` : undefined }}
          data-testid={`leader-row-${r.id}`}>
          <div className="absolute inset-y-0 left-0 transition-[width] duration-700 ease-out" style={{ width: `${(100 * r.score) / top}%`, background: `linear-gradient(90deg, ${r.color}55, ${r.color}22)` }} />
          <div className="relative flex items-center gap-[0.8vw] px-[0.9vw] py-[1vh]">
            <span className="font-display text-[min(2rem,3vh)] font-bold w-[3.2vh] text-slate-300">{i + 1}.</span>
            {r.mascot && <Mascot id={r.mascot} size="3.4vh" />}
            <span className="font-display text-[min(1.8rem,2.7vh)] font-bold flex-1 truncate" style={{ color: r.mascot ? "#fff" : r.color }}>{r.name}</span>
            {i === 0 && r.score > 0 && <Crown className="h-[2.8vh] w-[2.8vh] text-[#FACC15] anim-bob" />}
            <span key={r.score} className="font-display text-[min(2.2rem,3.4vh)] font-bold anim-pop">{r.score}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
